import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import MessageItem from './MessageItem';
import TypingIndicator from './TypingIndicator';

/**
 * MessageList Component
 * Displays list of messages with auto-scroll
 */
const MessageList = ({ messages, currentUserId, currentUserType, typingUsers = {} }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const isCurrentUser = (message) => {
    return (
      message.sender_id === currentUserId &&
      message.sender_type === currentUserType
    );
  };

  const typingUsersList = Object.values(typingUsers).filter(user => user.isTyping);

  return (
    <Box
      sx={{
        height: '100%',
        overflowY: 'auto',
        p: 2,
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
      }}
    >
      {messages.length === 0 ? (
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            No messages yet. Start the conversation!
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {messages.map((message, index) => (
            <MessageItem
              key={message.id || index}
              message={message}
              isCurrentUser={isCurrentUser(message)}
            />
          ))}

          {typingUsersList.map((user) => (
            <TypingIndicator key={user.id} userName={user.name} />
          ))}

          <div ref={messagesEndRef} />
        </Box>
      )}
    </Box>
  );
};

export default MessageList;
